const MUTABILITY_DETAILS_MAP = {
  fullName: 'name',
  nickname: 'nickname',
  timezone: 'zoneinfo',
  locale: 'locale',
  email: 'email',
  // extended profile
  title: 'extended_profile.job_title',
  phoneNumber: 'extended_profile.phone_number',
  companyName: 'extended_profile.organization',
  department: 'extended_profile.department',
  location: 'extended_profile.location'
};
const CUSTOM_FIELD_PLACE = {
  email: 'email.initiateChange',
  picture: 'avatar'
};
const getFieldConfig = (data, field) => {
  if ((field === 'email' || field === 'picture') && CUSTOM_FIELD_PLACE[field]) {
    return data[CUSTOM_FIELD_PLACE[field]];
  }
  const mappedFieldKey = MUTABILITY_DETAILS_MAP[field];

  // @ts-ignore
  return data['profile.write'][mappedFieldKey];
};
const getMutabilityConstraintFor = (data, field) => {
  const fieldConfig = getFieldConfig(data, field);
  if (!fieldConfig || fieldConfig.allowed) {
    return null;
  }
  const reason = fieldConfig.reason;
  return {
    field,
    reason: reason && reason.key || null
  };
};
export const transformUserManageConfig = data => ({
  mutabilityConstraints: Object.keys(MUTABILITY_DETAILS_MAP)
  // @ts-ignore
  .map(field => getMutabilityConstraintFor(data, field)).filter(truthy => truthy)
});